function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Logo from './logo';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LogoHp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return ___EmotionJSX(Logo, _extends({}, props, {
    ref: ref,
    viewBox: "0 0 32 32"
  }), ___EmotionJSX("path", {
    className: "singlecolor",
    d: "M16,32c-0.2,0-0.3,0-0.5,0l3.3-9h4.5c0.8,0,1.7-0.6,1.9-1.3l3.6-9.7c0.6-1.6-0.3-2.9-2-2.9h-6.2l-5.2,14.4 l0,0l-3,8.2C5.2,29.9,0,23.6,0,16C0,8.7,4.9,2.5,11.7,0.6L8.6,9l0,0L3.5,23h3.4l4.3-11.9h2.5L9.5,23h3.4l4-11.1 c0.6-1.6-0.3-2.9-2-2.9H12l3.3-9c0.2,0,0.5,0,0.7,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M25.7,11.1h-2.5l-3.6,9.8h2.5L25.7,11.1z"
  }), ___EmotionJSX("path", {
    className: "multicolor",
    fill: "#0096D6",
    d: "M16,32c-0.2,0-0.3,0-0.5,0l3.3-9h4.5c0.8,0,1.7-0.6,1.9-1.3l3.6-9.7c0.6-1.6-0.3-2.9-2-2.9h-6.2 l-5.2,14.4l0,0l-3,8.2C5.2,29.9,0,23.6,0,16C0,8.7,4.9,2.5,11.7,0.6L8.6,9l0,0L3.5,23h3.4l4.3-11.9h2.5L9.5,23h3.4l4-11.1 c0.6-1.6-0.3-2.9-2-2.9H12l3.3-9c0.2,0,0.5,0,0.7,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M25.7,11.1h-2.5l-3.6,9.8h2.5L25.7,11.1z"
  }));
});
LogoHp.displayName = 'LogoHp';
export default LogoHp;